<script>
	import { createEventDispatcher } from "svelte";

	import lookups from "../stores/lookupStore";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Select from "./Select.svelte";
	import CheckBoxButton from "./CheckBoxButton.svelte";
	import DatePicker from "./DatePicker.svelte";

	export let geneticDiagnoses = [];
	export let disabled = null;

	const dispatch = createEventDispatcher();

	const diagnosedId = $lookups.geneticConditionOutcomeType.filter((_) => _.lookupName === "Diagnosed")[0].id;

	const handleChange = (e, index) => {
		geneticDiagnoses[index].checked = e.target.checked;
		geneticDiagnoses = [...geneticDiagnoses];

		dispatch("diagnosis-change", { target: e.target, option: geneticDiagnoses[index] });
	};
</script>

<FormRow class="mt-2">
	<FormColumn col class="d-none d-md-block">
		<!-- svelte-ignore a11y-label-has-associated-control -->
		<label>Tested for</label>
	</FormColumn>
	<FormColumn col class="d-none d-md-block">
		<!-- svelte-ignore a11y-label-has-associated-control -->
		<label>Date Tested</label>
	</FormColumn>
	<FormColumn col class="d-none d-md-block">
		<!-- svelte-ignore a11y-label-has-associated-control -->
		<label>Outcome</label>
	</FormColumn>
	<FormColumn col class="d-none d-md-block">
		<!-- svelte-ignore a11y-label-has-associated-control -->
		<label>Date diagnosed</label>
	</FormColumn>
</FormRow>
<div class="diagnosis-list">
	{#each geneticDiagnoses as option, i (option)}
		{#if !disabled || option.checked}
			<FormRow class="mt-2">
				<FormColumn cols="3">
					<CheckBoxButton
						label={option.geneticConditionName}
						on:change={(e) => handleChange(e, i)}
						type="checkbox"
						bind:checked={option.checked}
						value={option.geneticConditionTypeId}
						id="gdiagnosis{i}"
						name="gdiagnosis"
						{disabled}
					/>
				</FormColumn>
				{#if option.checked}
					<FormColumn cols="3">
						<DatePicker
							required
							{disabled}
							placeholder="Date tested"
							validator={true}
							start={new Date(1950, 0, 1)}
							end={new Date()}
							bind:formattedSelected={option.dateTested}
							openOnClass="calendar-icon"
						/>
					</FormColumn>
					<FormColumn cols="3">
						<Select
							required
							{disabled}
							headOptionText="Select outcome..."
							bind:value={option.outcomeTypeId}
							optionList={$lookups.geneticConditionOutcomeType}
							textProperty="lookupName"
							valueProperty="id"
						/>
					</FormColumn>
					<FormColumn cols="3">
						{#if option.outcomeTypeId == diagnosedId}
							<DatePicker
								required
								{disabled}
								placeholder="Date diagnosed"
								validator={true}
								start={new Date(1950, 0, 1)}
								end={new Date()}
								bind:formattedSelected={option.dateDiagnosed}
								openOnClass="calendar-icon"
							/>
						{/if}
					</FormColumn>
				{:else}
					<FormColumn cols="3"></FormColumn>
					<FormColumn cols="3"></FormColumn>
					<FormColumn cols="3"></FormColumn>
				{/if}
			</FormRow>
		{/if}
	{/each}
</div>

<style>
	.diagnosis-list {
		border-top: 1px solid var(--color-border);
	}
</style>
